import { SectionMessage, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

export const EInvoicingReactivationPendingBanner = (): ReactElement | null => {
  const { t } = useTranslation()

  return (
    <Styled.SectionWrapper>
      <SectionMessage variant="neutral" title={t('dashboard.banner.e_invoicing.reactivation_pending.title')}>
        <Text>{t('dashboard.banner.e_invoicing.reactivation_pending.subtitle')}</Text>
      </SectionMessage>
    </Styled.SectionWrapper>
  )
}
